module.exports = __webpack_public_path__ + "static/media/logo.d9c2e85a.svg";